import React from "react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

// Cursor-style pager for endpoints that report only "is there a previous/next
// page" rather than a total row count. Components/List/Pagination.js is the
// numbered variant used where a total IS known - this one deliberately shows no
// page numbers, because with no total there is nothing to number towards.
// Styling reuses the same list-pagination classes so both read as one control.
const Paging = ({ current = 1, previousValue = false, nextValue = false, onPageChange, disabled = false }) => {
    const currentPage = Number(current) || 1;

    const goTo = (page) => {
        if (disabled || page < 1) return;
        onPageChange?.(page);
    };

    return (
        <div className="list-pagination">
            <span className="list-pagination-range text-muted small">Page {currentPage}</span>

            <div className="list-pagination-controls">
                <button
                    type="button"
                    className="btn btn-sm list-page-btn"
                    onClick={() => goTo(currentPage - 1)}
                    disabled={disabled || !previousValue || currentPage <= 1}
                    aria-label="Previous page"
                >
                    <IoChevronBack /> <span className="d-none d-sm-inline">Previous</span>
                </button>

                <button type="button" className="btn btn-sm list-page-current" disabled>
                    {currentPage}
                </button>

                <button
                    type="button"
                    className="btn btn-sm list-page-btn"
                    onClick={() => goTo(currentPage + 1)}
                    disabled={disabled || !nextValue}
                    aria-label="Next page"
                >
                    <span className="d-none d-sm-inline">Next</span> <IoChevronForward />
                </button>
            </div>
        </div>
    );
};

export default Paging;
